import url from 'url'
import R from 'ramda'
import { slugify } from 'lib/slugify'
import { getUrlStringWithParams, getUrlStringWithoutParams } from '../selectors/algolia'
import * as Constants from './constants'
export const getFirstFacetValue = (
  facetName: string,
  facetValues: Array<string>,
  options: Record<string, any>
): string => {
  const [facetValue] = facetValues || [] // Get First Item/Value

  if (facetName === 'is_publicly_searchable') {
    return facetValue ? 'searchable' : ''
  }

  return facetValue || ''
}
export const stringQuery = (key: string, value: string): string => {
  if (!key || !value) {
    return ''
  }

  return `${key}=${value}`
}
// Params ( styles, ['Fine Art', 'Figurative', 'Modern' ])
// Result => `styles[]=fine-art&styles[]=figurative&styles[]=modern`
export const arrayQuery = (key: string, values: Array<any>): string => {
  if (!values.length) {
    return ''
  }

  // If only 1 item NO BRACKETS => `styles=fine-art`
  return values.map((value) => `${key}${values.length > 1 ? '[]' : ''}=${slugify(value)}`).join('&')
}
export const urlQuery = (obj: Record<string, any>) => {
  const query = Object.entries(obj)
    .filter(([key, value]) => {
      // Remove EMPTY and FALSE values => '', false, 0
      if (!value) {
        return false
      }

      return true
    })
    .map(([key, value]) =>
      Array.isArray(value)
        ? arrayQuery(key, value.filter(Boolean))
        : stringQuery(String(key), String(value))
    )
    .filter(Boolean)
    .join('&')
  return query.length ? `?${query}` : ``
}
export const getAlgoliaQueryParams = (href: string = ''): Record<string, any> => {
  const { query } = url.parse(href, true)
  const { hitsPerPage, page } = query || {}
  return {
    hitsPerPage: hitsPerPage || 25,
    page,
  }
}
export const urlWithParams = (redux: Record<string, any>): string =>
  R.curry((reduxState, params) => getUrlStringWithParams(params)(reduxState))(redux)
export const urlWithoutParams = (redux: Record<string, any>): string =>
  R.curry((reduxState, params) => getUrlStringWithoutParams(params)(reduxState))(redux)
export default { ...Constants }